<template>
  <div class="main-content">
    <div class="substrate --for-promo">
      <div class="substrate --with-img">
        <div class="substrate__bg-wrapper">
          <picture>
            <source
              srcset="~/assets/img/main/main-promo-bg.webp"
              type="image/webp"
            />
            <img
              :src="require(`~/assets/img/main/main-promo-bg.png`)"
              alt=""
            />
          </picture>
        </div>
        <MainPromoBlockDesktop>
          <template #controls>
            <VButtonLinkMTSV2
              href="/user/organizer/"
              class="main-promo__controls_btn --violet-gradient --l"
            >
              <span>Попробовать бесплатно</span>
            </VButtonLinkMTSV2>
            <VButtonLinkMTSV2
              href="/user/demo/"
              class="main-promo__controls_btn --white --l"
            >
              <span>Оставить заявку</span>
              <VIconMTS :name="'mts/icon-mts--arrow-link-right'" width="16" height="16"/>
            </VButtonLinkMTSV2>
          </template>
        </MainPromoBlockDesktop>
      </div>
      <div class="container">
        <MainProductsListBlockDesktop
          @selected-section="handlerSelectedSection"
        />
      </div>
    </div>

    <div class="substrate --gray-gradient">
      <div class="container">
        <!-- Важно! Здесь нет LazyHydrate потому что внутри компонента есть должны переключатся вкладки пре клике на якорную ссылку выше в компоненте MainProductsListBlockDesktop -->
        <MainProductsBlockDesktop :name-selected-section="nameSelectedSection" />
        <LazyHydrate when-visible>
          <LazyLeaderVKSBlockDesktop />
        </LazyHydrate>
      </div>
    </div>

    <div class="substrate --with-img">
      <div class="substrate__bg-wrapper">
        <picture>
          <source
            srcset="~/assets/img/main/main-promo-bg.webp"
            type="image/webp"
          />
          <img
            :src="require(`~/assets/img/main/main-promo-bg.png`)"
            alt=""
          />
        </picture>
      </div>
      <div class="container">
        <LazyHydrate when-visible>
          <LazyOnPremiseBlockDesktop />
        </LazyHydrate>
      </div>
    </div>
    <div class="substrate --for-reviews">
      <div class="container">
        <LazyHydrate when-visible>
          <LazyReviewsBlockDesktop />
        </LazyHydrate>
      </div>
    </div>
    <div class="container">
      <LazyHydrate when-visible>
        <LazyAdvantagesBlockDesktop />
      </LazyHydrate>
    </div>

    <div class="substrate --gray-bg">
      <div class="container">
        <LazyHydrate when-visible>
          <LazyMainFAQBlockDesktop />
        </LazyHydrate>
      </div>
    </div>
  </div>
</template>

<script>
import LazyHydrate from 'vue-lazy-hydration'
import EventBus from '@/mixins/EventBus'
import MainMixin from '~/components/Page/Main/MainMixin'
import LazyAdvantagesBlockDesktop from '~/components/Desktop/Main/Lazy/LazyAdvantagesBlockDesktop.vue'
import LazyMainFAQBlockDesktop from '~/components/Desktop/Main/Lazy/LazyMainFAQBlockDesktop.vue'
import LazyLeaderVKSBlockDesktop from '~/components/Desktop/Main/Lazy/LazyLeaderVKSBlockDesktop.vue'
import LazyOnPremiseBlockDesktop from '~/components/Desktop/Main/Lazy/LazyOnPremiseBlockDesktop.vue'
import MainProductsBlockDesktop from '~/components/Desktop/Main/MainProductsBlockDesktop.vue'
import LazyReviewsBlockDesktop from '~/components/Desktop/Main/Lazy/LazyReviewsBlockDesktop.vue'
import MainPromoBlockDesktop from '~/components/Desktop/Main/MainPromoBlockDesktop'
import MainProductsListBlockDesktop from '~/components/Desktop/Main/MainProductsListBlockDesktop'
import VButtonLinkMTSV2 from '~/components/Common/MTS/VButtonLinkMTSV2.vue'
import VIconMTS from '~/components/Common/MTS/VIconMTS.vue'

export default {
  name: 'MainPageDesktop',
  components: {
    LazyOnPremiseBlockDesktop,
    LazyLeaderVKSBlockDesktop,
    MainProductsBlockDesktop,
    LazyMainFAQBlockDesktop,
    LazyReviewsBlockDesktop,
    LazyAdvantagesBlockDesktop,
    MainPromoBlockDesktop,
    MainProductsListBlockDesktop,
    VButtonLinkMTSV2,
    VIconMTS,
    LazyHydrate,
  },
  mixins: [EventBus, MainMixin],
}
</script>

<style lang="scss" scoped>
.main-content {
  font-family: $font-mts-compact;

  .container {
    max-width: 1440px;
    padding-left: 32px;
    padding-right: 32px;
  }

  .substrate {
    &.--with-img {
      padding: 32px 0;
      position: relative;

      .substrate__bg-wrapper {
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        z-index: -1;
        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }
    }
    &.--gray-bg {
      background: $color-gray-2;
    }
    &.--gray-gradient {
      background: linear-gradient(180deg, #f2f3f7 0%, #ffffff 100%);
    }
    &.--for-promo {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      // 72 - высота шапки, 57 -высота баннера !!! Важно!!! если отключается баннер на главной то и его высоту нужно убрать
      height: calc(100vh - 72px - 57px);
      max-height: 783px;
      & > div:first-child {
        flex: 1;
      }
    }
  }
}
</style>
